import React from 'react';
import './SessionTakeoverModal.css';
import { getTranslation } from '../languages/index.js';

const SessionTakeoverModal = ({ onConfirm, onCancel, uiLanguage = 'en' }) => {
    const t = (key, params = {}) => getTranslation(key, uiLanguage, params);
    return (
        <div className="session-takeover-overlay">
            <div className="session-takeover-modal">
                <div className="session-takeover-icon">⚠️</div>
                <h2>{t('activeSessionDetected')}</h2>
                <p>
                    {t('sessionTakeoverWarning')}
                </p>
                <p className="session-takeover-warning">
                    {t('sessionTakeoverContinueWarning')}
                </p>
                <div className="session-takeover-actions">
                    <button 
                        className="session-takeover-cancel"
                        onClick={onCancel}
                    >
                        {t('cancel')}
                    </button>
                    <button 
                        className="session-takeover-confirm"
                        onClick={onConfirm}
                    >
                        {t('continueAnyway')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionTakeoverModal;